import { runInAction } from 'mobx'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { LanguageIcon } from '@heroicons/react/24/outline'
import { useCallback, useState } from 'react'

import { LanguageSchema, Language } from '@campai/lib-common/entities'

import { webAppState } from '@/appState'

import { DebugButton } from './DebugButton'

export const SwitchLanguage = observer(() => {
    const { language: currentLanguage } = webAppState

    const [open, setOpen] = useState(false)

    const handleToggleOpen = useCallback(() => {
        setOpen((open) => !open)
    }, [])

    return (
        <>
            {open && (
                <div className="absolute right-0 top-full h-40 w-40 overflow-auto rounded-lg border border-neutral-300 bg-white p-2 shadow-lg dark:border-neutral-700 dark:bg-neutral-900">
                    {(Object.keys(LanguageSchema.enum) as Array<Language>).map((language) => (
                        <div
                            key={language}
                            className={classNames('cursor-pointer p-2 hover:bg-neutral-200 dark:hover:bg-neutral-800', {
                                'bg-selection-200 dark:bg-selection-700': currentLanguage === language,
                            })}
                            onClick={() => {
                                handleToggleOpen()
                                runInAction(() => {
                                    webAppState.language = language
                                })
                            }}
                        >
                            {language}
                        </div>
                    ))}
                </div>
            )}
            <DebugButton Icon={LanguageIcon} onClick={handleToggleOpen} />
        </>
    )
})
